import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen bg-gray-200 font-roboto" }
const _hoisted_2 = { class: "flex-1 flex flex-col overflow-hidden" }
const _hoisted_3 = { class: "flex-1 overflow-x-hidden overflow-y-auto bg-gray-200" }
const _hoisted_4 = { class: "container mx-auto px-6 py-8" }

import Sidebar from './Sidebar.vue'
import Header from './Header.vue'
import Footer from './Footer.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Sidebar),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header),
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createVNode(Footer)
    ])
  ]))
}
}

})